export enum UsageType
{
  PartLookup,
  Sms
}